export enum DisplayType {
  Always = 1,
  AfterConfirm = 2,
}
